import React from 'react';

export default () => {
  return <div className="text-center">Copyright © 2023 CepteŞok</div>;
};
